import { margin, marginBottom, media, padding, paddingBottom } from "../../styles";
import { applyOpacity } from "../../styles/utils";
import styled from "styled-components";
export const List = styled.ul`
  list-style: none;
  ${padding.zero}
  ${margin.zero}

  > li {
    &:not(:last-child) {
      ${marginBottom.m}
      @media ${media.mobile} {
        ${paddingBottom.m}
        border-bottom: 1px solid ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.1)}
      }
    }
  }
`;
export default List;
export { ListItem } from "./ListItem/ListItem";